import React from 'react'

export const InboxIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.9165 8.33301H6.24984M13.7498 8.33301H17.0832"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 8.80514C2.5 8.49465 2.57229 8.18843 2.71115 7.91072L4.44721 4.43858C4.786 3.76101 5.47852 3.33301 6.23607 3.33301H13.7639C14.5215 3.33301 15.214 3.76101 15.5528 4.43858L17.2889 7.91072C17.4277 8.18843 17.5 8.49465 17.5 8.80514V14.6663C17.5 15.7709 16.6046 16.6663 15.5 16.6663H4.5C3.39543 16.6663 2.5 15.7709 2.5 14.6663V8.80514Z"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 12.0587V5.83301"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 10L10.0708 12.7297L7.64083 10"
        stroke="#273754"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
